import styled from '@emotion/styled';
import React from 'react';
import { InputType, InputValueType } from '../types';
import { Label } from './Label';
import { NumberInput } from './NumberInput';
import { OptionButtons } from './OptionButtons';
import { Segment } from './Segment';
import { StyledInput } from './StyledInput';

interface InputProps {
	values: InputType;
	onChange: (values: InputType) => void;
}

const InputWrapper = styled.div`
	display: flex;
	flex: 1 1;

	> * {
		margin: 0 16px !important;
	}

	& :first-child {
		margin: 0 !important;
	}
`;

export const Input: React.FC<InputProps> = ({ values, onChange }) => {
	const handleChange = (index: number, newValue: InputValueType) => {
		onChange(
			values.map((item, i) => {
				if (index !== i) {
					return item;
				}

				return {
					...item,
					value: newValue
				} as InputType[0];
			})
		);
	};

	const isWide = values.length === 1;
	return (
		<Segment fluid basic>
			<Label>input</Label>
			<InputWrapper>
				{values.map((v, i) => {
					if (v.type === 'number') {
						return (
							<NumberInput
								key={`input.${i}`}
								isWide={isWide}
								value={v.value}
								onValueChange={(d) => handleChange(i, d)}
							/>
						);
					}

					if (v.type === 'options') {
						return (
							<OptionButtons
								key={`input.${i}`}
								options={v.options}
								onChange={(d) => handleChange(i, d as any)}
								isInput={true}
								defaultValue={v.value}
							/>
						);
					}
					return (
						<StyledInput
							key={`input.${i}`}
							placeholder="input"
							value={v.value}
							isWide={isWide}
							onChange={(_, d) => handleChange(i, d.value)}
						/>
					);
				})}
			</InputWrapper>
		</Segment>
	);
};
